<template>
  <v-dialog
      v-model="dialog"
      :width="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on" class="mt-n5 mx-1" dark :color="getEventColor">
        <span :class=getEventClass>{{ getEventClassName }}</span>
        <span>{{ getEventName }}</span>
      </v-btn>
    </template>
    <v-container fluid>
      <v-card
          class="py-3 px-3"
      >
        <v-card-title class="justify-center">
          {{ getEventName }}
        </v-card-title>
        <v-form
            ref="form"
            v-model="form"
            class="pa-4 pt-6"
        >
          <v-row>
            <v-col cols="12" v-if="userId === null">
              <v-autocomplete
                  :rules="[rules.required]"
                  v-model="localItem.user.id"
                  :items="userList"
                  label="User"
                  clearable
                  hint="Enter users name or employee number"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required, rules.date_before]"
                  :readonly="eventStartDate !== null"
                  label="Date start"
                  type="date"
                  v-model="localItem.event_start_date"
                  :value="localItem.event_start_date"
                  hint="Enter events date start"
                  @input="onInput"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required, rules.date_after]"
                  :readonly="eventStartDate !== null"
                  label="Date stop"
                  type="date"
                  v-model="localItem.event_stop_date"
                  :value="localItem.event_stop_date"
                  hint="Enter events date stop"
                  @input="onInput"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                  label="Comment"
                  v-model="localItem.comment"
                  hint="Enter events comment (min 5, max 50 chars)"
                  counter="50"
                  clearable
                  :rules="[rules.min(5), rules.max(50), rules.required]"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              :disabled="!form"
              text
              @click="onAdd"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'TimeTrackerNewDialogRange',
  props: {
    length: {default: null},
    disabled: {default: false},
    event: {type: String, default: 'NoName'},
    userId: {default: null},
    eventStartDate: {default: null},
  },

  computed: {
    ...mapGetters('TimeTracker', ['getColumns',]),
    ...mapFields('TimeTracker', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),

    userList() {
      let user_list = []
      for (let row of this.itemListHuman)
        if (row.active)
          user_list.push({
            text: row.user + '(' + row.employee_number + ')',
            value: row.id
          })
      return user_list
    },

    getEventColor() {
      return this.local_phrase[this.event].color
    },
    getEventClass() {
      return "material-icons " + this.local_phrase[this.event].class
    },
    getEventClassName() {
      return this.local_phrase[this.event].class
    },
    getEventName() {
      return this.local_phrase[this.event].de
    },
  },

  methods: {
    ...mapActions('TimeTracker', ['fetchSaveItemField']),
    ...mapActions('CalendarEvent', {'fetchItemListCalendar': 'fetchItemList'}),
    onAdd() {
      console.log('onAdd', this.localItem)
      this.localItem.event_start = this.localItem.event_start_date + "T06:00:00Z"
      this.localItem.event_stop = this.localItem.event_stop_date + "T06:00:00Z"

      let fields_dict = {}
      fields_dict['event'] = this.localItem.event
      fields_dict['comment'] = this.localItem.comment
      fields_dict['event_start'] = this.localItem.event_start
      fields_dict['event_stop'] = this.localItem.event_stop
      fields_dict['user'] = {id: this.localItem.user.id}
      this.fetchSaveItemField({
        itemId: null,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'TimeTrackerEventDTO', from_consumer: 'TimeTrackerEventDTO'}
      })
      this.dialog = false
    },
    onInput() {
      this.$refs.form.validate()
    },
  },

  mounted() {
    this.localItem.event = this.event
    this.localItem.user = {id: this.userId}
    this.localItem.event_start_date = this.eventStartDate
    this.localItem.event_stop_date = this.eventStartDate
  },

  data() {
    return {
      dialog: false,
      form: false,
      localItem: {
        user: {id: null},
        event: null,
        event_start: null,
        event_start_date: null,
        event_stop_date: null,
        event_stop: null,
        duration: "00:00",
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
        date_after: v => !!v && (v >= this.localItem.event_start_date || !this.localItem.event_start_date) || `Invalid date`,
        date_before: v => !!v && (v <= this.localItem.event_stop_date || !this.localItem.event_stop_date) || `Invalid date`,
      },
    }
  },
}

</script>


<style scoped lang="scss">

</style>